import { render, staticRenderFns } from "./webhook-form.vue?vue&type=template&id=00e8b85d&"
import script from "./webhook-form.vue?vue&type=script&lang=js&"
export * from "./webhook-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports